import { Injectable } from '@angular/core';
import { AppStore } from '@app/app.store';

@Injectable({ providedIn: 'root' })
export class ParameterResolutionService {
  public BOOLEAN_VALUE_TRUE = 'true';
  public BOOLEAN_VALUE_FALSE = 'false';

  constructor(protected appStore: AppStore) {}

  resolveValue(code: string): string {
    return this.appStore.state.session.parameters.values[code];
  }

  resolveNumericValue(code: string) {
    return this.fromTextToNumeric(this.resolveValue(code));
  }

  resolveBooleanValue(code: string) {
    return this.fromTextToBoolean(this.resolveValue(code));
  }

  // resolveDateValue(code: string) {}

  resolveListValue(code: string) {
    return this.fromTextToList(this.resolveValue(code));
  }

  fromTextToNumeric(textValue: string): number {
    return parseInt(textValue, 10);
  }

  fromTextToBoolean(textValue: string): boolean {
    return this.BOOLEAN_VALUE_TRUE === textValue;
  }

  // fromTextToDate(textValue: string): Timestamp {}

  fromTextToList(textValue: string): string {
    return textValue;
  }

  fromNumericToText(numericValue: number): string {
    return numericValue.toString();
  }

  fromBooleanToText(booleanValue: boolean): string {
    return booleanValue ? this.BOOLEAN_VALUE_TRUE : this.BOOLEAN_VALUE_FALSE;
  }

  // fromDateToText(dateValue: Timestamp): string { }

  fromListToText(listValue: string): string {
    return listValue;
  }
}
